<i18n>
    {
        cn: {
            message: '留言',
            name: '姓名',
            phone: '手机号',
            email: '邮箱',
            address: '地址',
            theme: '主题',
            content: '留言',
            submit: '提交',
            "please_enter_name": "请输入姓名",
            "please_enter_phone": "请输入手机号",
            "please_enter_email": "请输入邮箱",
            "invalid_email_format": "邮箱格式有误",
            "please_enter_address": "请输入地址",
            "please_enter_theme": "请输入主题",
            "please_enter_content": "请输入留言",
            "submission_successful": "上传成功",
            "submission_failed": "上传失败",
            "contact_us": "联系我们",
            "tel": "请致电",
        },
        en: {
            message: 'Message',
            name: 'Name',
            phone: 'Phone',
            email: 'E-mail',
            address: 'Address',
            theme: 'Theme',
            content: 'Message',
            submit: 'Submit',
            "please_enter_name": "Please enter name",
            "please_enter_phone": "Please enter phone",
            "please_enter_email": "Please enter email",
            "invalid_email_format": "Invalid email format",
            "please_enter_address": "Please enter address",
            "please_enter_theme": "Please enter theme",
            "please_enter_content": "Please enter message",
            "submission_successful": "Submission successful",
            "submission_failed": "Submission failed",
            "contact_us": "Contact Us",
            "tel": "Tel",
        }
    }
</i18n>
<script>
import { mapState } from 'vuex';
export default {
    name: "contactUs",
    data() {
        return {
            name: '',
            phone: '',
            email: '',
            address: '',
            content: '',
            theme: '',
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['contactData'])
    },
    components: {
        
    },
    mounted() {
        this.$store.dispatch('getContactUs');
    },
    destroyed() {},
    watch: {},
    methods: {
        submit() {
            if(this.isLoading){
                return false;
            }
            if(this.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.name.focus();
                this.$showToast({ text: this.$t('please_enter_name') }); //
                // this.$showToast({ text: 'Please enter name' }); //请输入姓名
                return false;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: this.$t('please_enter_phone') }); //请输入手机号
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: this.$t('please_enter_email') }); //请输入邮箱
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: this.$t('invalid_email_format') }); //邮箱格式有误
                return false;
            }
            if(this.address.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.address.focus();
                this.$showToast({ text: this.$t('please_enter_address') }); //请输入地址
                return false;
            }
            if(this.theme.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.theme.focus();
                this.$showToast({ text: this.$t('please_enter_theme') }); //请输入主题
                return false;
            }
            if(this.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.content.focus();
                this.$showToast({ text: this.$t('please_enter_content') }); //请输入内容
                return false;
            }
            this.isLoading = true;
            this.$showLoading();
            this.$store.dispatch('submitMessage', {
                type: '联系我们',
                name: this.name,
                email: this.email,
                phone: this.phone,
                address: this.address,
                message: this.content,
                theme: this.theme,
            }).then((result) => {
                this.isLoading = false;
                this.$hideLoading();
                if (result.code == 100) { 
                    this.$showToast({ text: this.$t('submission_successful') });
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.address = '';
                    this.theme = '';
                    this.content = '';
                } else {
                    this.$showToast({ text: this.$t('submission_failed') });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: this.$t('submission_failed') });
            });
        }
    },
};
</script>

<template>
    <div class="contactUs layout_body">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url(${contactData.banner});`"></div>
        </div>
        <div class="layout_main">
            <div class="layout_content wrapper">
                <div class="title">{{ $t('contact_us') }}</div>
                <div class="list flex flex_wrap justify_between">
                    <div class="item" v-for="(item, index) in contactData.list" :key="index">
                        <div class="name layout_flex_center">{{ item.name }}</div>
                        <div class="tel" v-if="item.phone">{{ $t('tel') }}：<a :href="`tel:+${item.phone}`">{{ item.phone }}</a></div>
                        <div class="email" v-if="item.email">E-mail：<a :href="`mailto:${item.email}`">{{ item.email }}</a></div>
                    </div>
                    <div class="form">
                        <div class="name">{{ $t('message') }}</div>
                        <div class="input_group">
                            <input type="text" ref="name" v-model="name" :placeholder="$t('name')"/>
                            <input type="tel" ref="phone" v-model="phone" :placeholder="$t('phone')"/>
                        </div>
                        <div class="input_group">
                            <input type="text" ref="email" v-model="email" :placeholder="$t('email')"/>
                            <input type="text" ref="address" v-model="address" :placeholder="$t('address')"/>
                        </div>
                        <div class="input_group">
                            <input type="text" ref="theme" v-model="theme" :placeholder="$t('theme')"/>
                        </div>
                        <div class="input_group">
                            <textarea ref="content" v-model="content" :placeholder="$t('message')"></textarea>
                        </div>
                        <div class="input_group justify_end">
                            <div class="btn layout_flex_center" @click="submit">{{ $t('submit') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.wrapper{
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
    .title{
        font-size: .25rem;
        padding: .2rem 0 .4rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            text-align: center;
            padding: .4rem 0 .8rem;
            font-weight: bold;
        }
    }
    .list{
        .item{
            width: 3.2rem;
            margin-bottom: .5rem;
            .name{
                font-size: .2rem;
                margin-bottom: .2rem;
                height: .4rem;
                border: 1px solid #666666;
                color: #666666;
            }
            .tel,
            .email{
                font-size: .18rem;
                white-space: nowrap;
            }
        }
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            align-items: center;
            .item{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .name{
                    width: 3.2rem;
                    height: .5rem;
                    font-size: .28rem;
                    margin-bottom: .4rem;
                }
                .tel,
                .email{
                    font-size: .28rem;
                    line-height: 1.8;
                }
            }
        }
    }
    .form{
        width: 7.2rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .name{
            font-size: .2rem;
            color: #666;
            margin-bottom: .2rem;
            @media only screen and (max-width: 750px) {
                font-size: .36rem;
                text-align: center;
                color: var(--font_color);
                font-weight: bold;
                margin-bottom: .4rem;
            }
        }
        .input_group{
            width: 100%;
            display: flex;
            gap: .24rem;
            margin-bottom: .24rem;
            input,
            textarea,
            .btn{
                width: 0;
                flex: 1;
                height: .4rem;
                font-size: .2rem;
                border: 1px solid #666;
                padding: 0 .15rem;
                box-sizing: border-box;
                &::placeholder{
                    color: #999999;
                }
            }
            textarea{
                height: 1.7rem;
                padding: .1rem .15rem;
            }
            .btn{
                flex: none;
                width: .9rem;
                cursor: pointer;
            }
            @media only screen and (max-width: 750px) {
                gap: .3rem;
                input,
                textarea,
                .btn{
                    height: .68rem;
                    font-size: .28rem;
                    padding: 0 .2rem;
                    // padding: 0;
                }
                textarea{
                    height: 2.7rem;
                    padding: .2rem;
                }
                .btn{
                    width: 1.2rem;
                }
            }
        }
    }
}
</style>